export const fieldError = message =>
  new Error(message || 'Preenchimento incorreto');
